/**
 * Avatar Configuration
 *
 * Generates personalized avatars from user initials with
 * professional color and style options.
 */

export interface AvatarStyle {
  id: string;
  name: string;
  dicebearStyle: string;
}

export interface AvatarColor {
  id: string;
  name: string;
  hex: string;
}

export const AVATAR_STYLES: AvatarStyle[] = [
  { id: 'initials', name: 'Initials', dicebearStyle: 'initials' },
  { id: 'shapes', name: 'Geometric', dicebearStyle: 'shapes' },
  { id: 'rings', name: 'Rings', dicebearStyle: 'rings' },
  { id: 'identicon', name: 'Identicon', dicebearStyle: 'identicon' },
];

export const AVATAR_COLORS: AvatarColor[] = [
  { id: 'slate', name: 'Slate', hex: '475569' },
  { id: 'navy', name: 'Navy', hex: '1e3a5f' },
  { id: 'teal', name: 'Teal', hex: '0f766e' },
  { id: 'emerald', name: 'Emerald', hex: '047857' },
  { id: 'indigo', name: 'Indigo', hex: '4338ca' },
  { id: 'violet', name: 'Violet', hex: '6d28d9' },
  { id: 'rose', name: 'Rose', hex: 'be123c' },
  { id: 'amber', name: 'Amber', hex: 'b45309' },
];

export function generateAvatarUrl(
  name: string,
  style: AvatarStyle,
  color: AvatarColor
): string {
  const seed = encodeURIComponent(name.trim() || 'User');
  return `https://api.dicebear.com/7.x/${style.dicebearStyle}/svg?seed=${seed}&backgroundColor=${color.hex}`;
}

export function getInitials(name?: string): string {
  if (!name?.trim()) return '?';
  return name
    .trim()
    .split(/\s+/)
    .map(n => n[0])
    .join('')
    .toUpperCase()
    .slice(0, 2);
}
